import React, { useState, useEffect } from "react";
import "../../ViewInfo.css";
import { TextField, Button, MenuItem } from "@mui/material";
import { Get_One_Nested_Prop_From_MongoDB } from "../../../api/Get_One_Nested_Prop_From_MongoDB";
import { useParams } from "react-router-dom";
import { Update_To_MongoDB_By_ID } from "../../../api/Update_To_MongoDB_By_ID";
import { StudentuseAuth } from "../../../security/StudentUseAuth";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import { Student_Get_One_Nested_Prop_From_MongoDB } from "../../../api/Student_Get_One_Nested_Prop_From_MongoDB";
import { Student_Update_To_MongoDB_By_ID } from "../../../api/Student_Update_To_MongoDB_By_ID";
import { Link } from "react-router-dom";
import SEFChangePage from "../../../components/ChangePage/SEFChangePage";
import getPhotoGroup from "../../../../functions/getPhotoGroup";
import { Student_Get_One_From_MongoDB } from "../../../api/Student_Get_One_From_MongoDB";
import { Student_Get_One_Photo_From_MongoDB } from "../../../api/Student_Get_One_Photo_From_MongoDB";
import { handleFileInput } from "../../../components/Photos/handleFileInput";
import { Consultant_Get_One_Photo_From_MongoDB } from "../../../../Consultants/api/Consultant_Get_One_Photo_From_MongoDB";
import { ConsultantuseAuth } from "../../../../Consultants/security/ConsultantUseAuth";
import { Consultant_Get_One_Nested_Prop_From_MongoDB } from "../../../../Consultants/api/Consultant_Get_One_Nested_Prop_From_MongoDB";
import { Consultant_Update_To_MongoDB_By_ID } from "../../../../Consultants/api/Consultant_Update_To_MongoDB_By_ID";
import { Get_One_Choose_Fields_From_MongoDB } from "../../../../Consultants/api/Get_One_Choose_Fields_From_MongoDB";

function ViewSEFPhotosInfo() {
  const { id } = useParams();

  let logoutStudent;
  let logoutConsultant;
  if (window.location.href.indexOf("Student") > -1) {
    logoutStudent = StudentuseAuth().logoutStudent;
  } else {
    logoutConsultant = ConsultantuseAuth().logoutConsultant;
  }

  const [SEFProgress, setSEFProgress] = useState({
    PhotosInfo: "",
  });

  const [obj_EC, setobj_EC] = useState({});
  const [obj_assignedEC, setobj_assignedEC] = useState({});
  const [StudentData, setStudentData] = useState({});

  useEffect(() => {
    if (window.location.href.indexOf("Student") > -1) {
      Student_Get_One_Nested_Prop_From_MongoDB(
        "Registers_2025",
        "All",
        localStorage.getItem("Student_id"),
        "SEFProgress",
        setSEFProgress,
        logoutStudent
      );
      Student_Get_One_Photo_From_MongoDB(
        "ID_Image_Front_2025",
        getPhotoGroup(id.slice(-1)),
        localStorage.getItem("Student_id"),
        setID_Image_Front_2025,
        logoutStudent
      );
      Student_Get_One_Photo_From_MongoDB(
        "ID_Image_Back_2025",
        getPhotoGroup(id.slice(-1)),
        localStorage.getItem("Student_id"),
        setID_Image_Back_2025,
        logoutStudent
      );
      Student_Get_One_Photo_From_MongoDB(
        "Clear_Image_2025",
        getPhotoGroup(id.slice(-1)),
        localStorage.getItem("Student_id"),
        setClear_Image_2025,
        logoutStudent
      );
    } else {
      Consultant_Get_One_Nested_Prop_From_MongoDB(
        "Registers_2025",
        "All",
        id,
        "SEFProgress",
        setSEFProgress,
        logoutConsultant
      );
      Consultant_Get_One_Photo_From_MongoDB(
        "ID_Image_Front_2025",
        getPhotoGroup(id.slice(-1)),
        id,
        setID_Image_Front_2025,
        logoutConsultant
      );
      Consultant_Get_One_Photo_From_MongoDB(
        "ID_Image_Back_2025",
        getPhotoGroup(id.slice(-1)),
        id,
        setID_Image_Back_2025,
        logoutConsultant
      );
      Consultant_Get_One_Photo_From_MongoDB(
        "Clear_Image_2025",
        getPhotoGroup(id.slice(-1)),
        id,
        setClear_Image_2025,
        logoutConsultant
      );
      Get_One_Choose_Fields_From_MongoDB(
        "Registers_2025",
        "All",
        id,
        { IPInfo: 1, SEFProgress: 1 },
        setStudentData,
        logoutConsultant
      );
    }
  }, []);

  useEffect(() => {
    //if the web page URL contains the string Student
    if (window.location.href.indexOf("Student") > -1) {
    } else {
      Get_One_Choose_Fields_From_MongoDB(
        "IP",
        "EC",
        localStorage.getItem("Consultant_id"),
        {},
        setobj_EC,
        logoutConsultant
      );
      if (StudentData && StudentData._id && StudentData._id.length === 24) {
        Get_One_Choose_Fields_From_MongoDB(
          "IP",
          "EC",
          StudentData.IPInfo?.EC_ID,
          { _id: 1, "MetaData.Agency_id": 1 },
          setobj_assignedEC,
          logoutConsultant
        );
      }
    }
  }, [StudentData]);

  let EC_Check_Permissions = false;
  if (
    localStorage.getItem("Consultant_id") === StudentData.IPInfo?.EC_ID ||
    (obj_EC.MetaData?.Admin === "Yes" &&
      obj_EC.MetaData?.Agency_id === obj_assignedEC.MetaData?.Agency_id)
  ) {
    EC_Check_Permissions = true;
  }

  const [status, setStatus] = useState(false);

  const handleSaveProgress = () => {
    if (window.location.href.indexOf("Student") > -1) {
      Student_Update_To_MongoDB_By_ID(
        {
          "SEFProgress.PhotosInfo": "In_Progress",
        },
        "Registers_2025",
        "All",
        setStatus,
        localStorage.getItem("Student_id"),
        "Your progress has been saved, you may now navigate to another page using the buttons at the bottom or close this tab",
        logoutStudent
      );
    } else {
      Consultant_Update_To_MongoDB_By_ID(
        {
          "SEFProgress.PhotosInfo": "In_Progress",
        },
        "Registers_2025",
        "All",
        setStatus,
        id,
        logoutConsultant
      );
    }
    setPageButtonStatus(true);
  };

  const handleSubmit = () => {
    if (window.location.href.indexOf("Student") > -1) {
      Student_Update_To_MongoDB_By_ID(
        {
          "SEFProgress.PhotosInfo": "Awaiting_Review",
        },
        "Registers_2025",
        "All",
        setStatus,
        localStorage.getItem("Student_id"),
        "This page has been submitted, you may now navigate to another page using the buttons at the bottom or close this tab",
        logoutStudent
      );
    } else {
      Consultant_Update_To_MongoDB_By_ID(
        {
          "SEFProgress.PhotosInfo": "Awaiting_Review",
        },
        "Registers_2025",
        "All",
        setStatus,
        id,
        logoutConsultant
      );
    }
    setSEFProgress({
      PhotosInfo: "Complete",
    });
    setPageButtonStatus(true);
  };

  const [PageButtonStatus, setPageButtonStatus] = useState(false);

  /////////////////////////////////////////////////////////////////////
  //-Photo Stuff

  function handlePhotoUpload(e, setState, State, Type, Group, id) {
    window.location.href.indexOf("Student") > -1
      ? handleFileInput(e, setState, State, Type, Group, id, "Student")
      : handleFileInput(e, setState, State, Type, Group, id, "Consultant");
  }

  //States for Photos
  const [ID_Image_Front_2025, setID_Image_Front_2025] = useState({
    myFile: "Loading...",
  });
  const [ID_Image_Back_2025, setID_Image_Back_2025] = useState({
    myFile: "Loading...",
  });
  const [Clear_Image_2025, setClear_Image_2025] = useState({
    myFile: "Loading...",
  });
  const isFormComplete =
    ID_Image_Front_2025.myFile &&
    ID_Image_Front_2025.myFile !== "Loading..." &&
    ID_Image_Front_2025.serverCheck === "Yes" &&
    Clear_Image_2025.myFile &&
    Clear_Image_2025.myFile !== "Loading..." &&
    Clear_Image_2025.serverCheck === "Yes";

  let Allowed_To_Upload = false;
  if (
    SEFProgress.PhotosInfo !== "Complete" &&
    SEFProgress.PhotosInfo !== "Awaiting_Review"
  ) {
    Allowed_To_Upload = true;
  }

  console.log("ID_Image_Front_2025");
  console.log(ID_Image_Front_2025);

  if (
    window.location.href.indexOf("Student") < 0 &&
    !EC_Check_Permissions &&
    (Object.keys(StudentData).length === 0 ||
      Object.keys(obj_EC).length === 0 ||
      Object.keys(obj_assignedEC).length === 0)
  ) {
    return (
      <div className="view-basic-info-container">
        <h1>Checking Access Permissions...</h1>
      </div>
    );
  } else if (
    window.location.href.indexOf("Student") < 0 &&
    !EC_Check_Permissions
  ) {
    return (
      <div className="view-basic-info-container">
        <h1>Access Denied</h1>
      </div>
    );
  } else {
    return (
      <div className="view-basic-info-container">
        <h1>Photos</h1>
        {/* {id}
      <br></br>
      Number : {id.slice(-1)}
      <br></br>
      Group : {getPhotoGroup(id.slice(-1))} */}
        {SEFProgress &&
        SEFProgress.PhotosInfo &&
        (SEFProgress.PhotosInfo === "Complete" ||
          SEFProgress.PhotosInfo === "Awaiting_Review") ? (
          <strong>
            If you need to make further changes, please contact InvestIN at
            info@investin.org or speak to your known contact
          </strong>
        ) : (
          ""
        )}
        <p style={{ fontSize: "1.2rem" }}>
          For all students enrolling on to a summer programme, we require the
          following images. Please note, that you can only upload files of size
          16MB and under.
        </p>

        <div>
          <h1>ID Image</h1>
          <p style={{ fontSize: "1.2rem" }}>
            A photocopy of the student’s photo ID. This document must clearly
            show the <b>student’s name, and date of birth</b> and include a
            photo. This should be a{" "}
            <b>
              formal identification document such as a passport, driver's
              licence, resident card, or national ID card etc.
            </b>{" "}
            ID cards sometimes have the date of birth on the back of the card,
            i.e. BRP cards. Please ensure you upload
            <b> both sides </b>of the card if this is the case to prevent delays
            in approving the enrolment form
          </p>
          <h2>Front of ID Image</h2>
          <img
            src={`${process.env.PUBLIC_URL}/logo192.png`}
            alt="Image"
            style={{ maxWidth: "100%", height: "auto" }}
          />
          <div
            className=""
            style={{
              width: "100%",
              height: "auto",
              display: "flex",
              flex: "1",
              flexDirection: "column",
            }}
          >
            <label>
              {ID_Image_Front_2025.myFile &&
              ID_Image_Front_2025.myFile === "Loading..." ? (
                "Loading..."
              ) : ID_Image_Front_2025.myFile &&
                ID_Image_Front_2025.myFile !== "Loading..." ? (
                <img
                  src={ID_Image_Front_2025.myFile}
                  alt=""
                  className="maxheight300px maxwidth300px"
                  style={{ maxWidth: "300px", maxHeight: "300px" }}
                ></img>
              ) : (
                "No Image Found"
              )}{" "}
              {ID_Image_Front_2025.myFile &&
              ID_Image_Front_2025.myFile !== "Loading..." &&
              ID_Image_Front_2025.serverCheck !== "Yes" ? (
                <div>Uploading....</div>
              ) : (
                ""
              )}
            </label>
            {Allowed_To_Upload ? (
              <input
                type="file"
                lable="Image"
                name="myFile"
                id="file-upload"
                accept=".jpeg, .png, .jpg"
                onChange={(e) =>
                  handlePhotoUpload(
                    e,
                    setID_Image_Front_2025,
                    ID_Image_Front_2025,
                    "ID_Image_Front_2025",
                    getPhotoGroup(id.slice(-1)),
                    id
                  )
                }
              ></input>
            ) : (
              <></>
            )}
          </div>
        </div>
        <div>
          <h2>Back of ID Image</h2>
          <img
            src={`${process.env.PUBLIC_URL}/logo192.png`}
            alt="Image"
            style={{ maxWidth: "100%", height: "auto" }}
          />
          <div
            className=""
            style={{
              width: "100%",
              height: "auto",
              display: "flex",
              flex: "1",
              flexDirection: "column",
            }}
          >
            <label>
              {ID_Image_Back_2025.myFile &&
              ID_Image_Back_2025.myFile === "Loading..." ? (
                "Loading..."
              ) : ID_Image_Back_2025.myFile &&
                ID_Image_Back_2025.myFile !== "Loading..." ? (
                <img
                  src={ID_Image_Back_2025.myFile}
                  alt=""
                  className="maxheight300px maxwidth300px"
                  style={{ maxWidth: "300px", maxHeight: "300px" }}
                ></img>
              ) : (
                "No Image Found"
              )}
              {ID_Image_Back_2025.myFile &&
              ID_Image_Back_2025.myFile !== "Loading..." &&
              ID_Image_Back_2025.serverCheck !== "Yes" ? (
                <div>Uploading....</div>
              ) : (
                ""
              )}
            </label>
            {Allowed_To_Upload ? (
              <input
                type="file"
                lable="Image"
                name="myFile"
                id="file-upload"
                accept=".jpeg, .png, .jpg"
                onChange={(e) =>
                  handlePhotoUpload(
                    e,
                    setID_Image_Back_2025,
                    ID_Image_Back_2025,
                    "ID_Image_Back_2025",
                    getPhotoGroup(id.slice(-1)),
                    id
                  )
                }
              ></input>
            ) : (
              <></>
            )}
          </div>
        </div>
        <h1>Clear Headshot Image</h1>
        <p>
          A clear photograph of the student’s face and shoulders, taken straight
          on within the last 12 months. This should be a photograph of the
          student’s face and must not include others (e.g. a passport, annual
          school photo, or student selfie provided the image is appropriate).
        </p>
        <div>
          <h2>Clear Image</h2>
          <img
            src={`${process.env.PUBLIC_URL}/logo192.png`}
            alt="Image"
            style={{ maxWidth: "100%", height: "auto" }}
          />
          <div
            className=""
            style={{
              width: "100%",
              height: "auto",
              display: "flex",
              flex: "1",
              flexDirection: "column",
            }}
          >
            <label>
              {Clear_Image_2025.myFile &&
              Clear_Image_2025.myFile === "Loading..." ? (
                "Loading..."
              ) : Clear_Image_2025.myFile &&
                Clear_Image_2025.myFile !== "Loading..." ? (
                <img
                  src={Clear_Image_2025.myFile}
                  alt=""
                  className="maxheight300px maxwidth300px"
                  style={{ maxWidth: "300px", maxHeight: "300px" }}
                ></img>
              ) : (
                "No Image Found"
              )}
              {Clear_Image_2025.myFile &&
              Clear_Image_2025.myFile !== "Loading..." &&
              Clear_Image_2025.serverCheck !== "Yes" ? (
                <div>Uploading....</div>
              ) : (
                ""
              )}
            </label>
            {Allowed_To_Upload ? (
              <input
                type="file"
                lable="Image"
                name="myFile"
                id="file-upload"
                accept=".jpeg, .png, .jpg"
                onChange={(e) =>
                  handlePhotoUpload(
                    e,
                    setClear_Image_2025,
                    Clear_Image_2025,
                    "Clear_Image_2025",
                    getPhotoGroup(id.slice(-1)),
                    id
                  )
                }
              ></input>
            ) : (
              <></>
            )}
          </div>
        </div>
        <form className="view-basic-info-form">
          {/* Questions go here */}
          {window.location.href.indexOf("Student") > -1 ? (
            <SEFChangePage
              Page={"PhotosInfo"}
              PageButtonStatus={PageButtonStatus}
            />
          ) : (
            <></>
          )}{" "}
          <h3>
            Once this page is completed and you have completed every question,
            please click "Submit" to complete the page and send it for review by
            InvestIN. Otherwise, click "Save" if you are not ready to complete
            the page and wish to return later to make changes
          </h3>
          <div className="view-basic-info-buttons">
            <Button
              variant="contained"
              color="primary"
              onClick={handleSaveProgress}
              disabled={
                status ||
                (SEFProgress &&
                  SEFProgress.PhotosInfo &&
                  (SEFProgress.PhotosInfo === "Complete" ||
                    SEFProgress.PhotosInfo === "Awaiting_Review"))
              }
            >
              Save Progress
            </Button>
            <Button
              variant="contained"
              color="secondary"
              onClick={handleSubmit}
              disabled={
                !isFormComplete ||
                status ||
                (SEFProgress &&
                  SEFProgress.PhotosInfo &&
                  (SEFProgress.PhotosInfo === "Complete" ||
                    SEFProgress.PhotosInfo === "Awaiting_Review"))
              }
            >
              Submit
            </Button>
          </div>
        </form>
      </div>
    );
  }
}

export default ViewSEFPhotosInfo;
